<template>
  <div class="bg-dark-create" :class="[showmodal?'open':'']"></div>
  <div class="form-create-module editquestion" :class="[showmodal?'open':'']">
    <div class="modal editquestion" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Crair Questão</h5>
          </div>
          <div class="modal-body">
            <section class="section link-list primary">
              <!--Content Section-->
              <div class="link-list-content">
                <div class="content-link create-course">
                  <div class="link" @click="changeView(0)">
                    <a class="link-content" :class="[ viewtab? 'active': '']">
                      Questão
                    </a>
                  </div>
                  <div class="link" @click="changeView(1)">
                    <a class="link-content" :class="[ !viewtab? 'active': '']">
                      Alternativas
                    </a>
                  </div>
                </div>
              </div>
            </section>

            <div class="form-group text-area" v-show="viewtab">
              <QuillEditor
                theme="snow"
                toolbar="essential"
                v-model:content="title"
                contentType="html"
              />
            </div>

            <div class="form-group" v-show="!viewtab">
              <div class="modal-body">
                <div class="flex">
                  <div class="row">
                    <div
                      class="form-group"
                      style="margin: 0 !important; border: none"
                    >
                      <div class="form-label">
                        <label>Selecione o número de alternativas</label>
                      </div>
                      <div class="form-input">
                        <select
                          v-model="numberAnswer"
                          class="select-mode"
                          @change="updateAnswers"
                        >
                          <option value="0" disabled selected>-</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="showAsnwer">
                <div
                  class="question"
                  v-for="index in computedAnswerRange"
                  :key="index"
                >
                  <div class="input_awmser">
                    <input
                      type="radio"
                      name="correct"
                      :value="index"
                      v-model="correctOption"
                    />
                    <label>{{titleOption[index]}}</label>
                  </div>
                  <div class="text_awmser">
                    <QuillEditor
                      @input="updateContent(i-1, $event.srcElement.innerHTML)"
                      theme="snow"
                      toolbar="essential"
                      v-model:content="asnwers[index]"
                      contentType="html"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="closetab()"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button type="button" @click="saveModule()" class="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/utils/answer';
import { mapState } from 'vuex';

export default {
  data(){
    return{
        showmodal:'',
        nameModule:'',
        demo:'',
        title:null,
        viewtab:true,
        titleQuestion:'',
        asnwers:[],
        correctOption:null,
        titleOption: ['a )','b )','c )','d )','e )'],
        numberAnswer: 0,
        showAsnwer:false,

    }
  },
  props: {
    show: Boolean,
    data: [],
    idQuiz:Boolean
  },
  computed:{
    ...mapState(['token']),
    computedAnswerRange() {
      if(this.numberAnswer!=null){
        return Array.from({ length: this.numberAnswer }, (_, index) => index);
      }
    }
  },
  methods: {
    closetab() {
      this.showmodal = false;
      this.$emit('open-tab', this.showmodal)
    },
    opentab(){
        this.show=true,
        this.$emit('open-tab', this.showmodal)
    },
    async createQuestion(){
      const obj = {
        "question": {
          "description": this.title,
          "status": 1,
          "quiz": {
              "id": this.idQuiz
          }
        },
        "answers": this.criarObjetoDeRespostas(this.asnwers, this.correctOption)
      }
      try {
          const response = await api.createQuestionAnswer(obj, this.token);
      } catch (error) {
        console.error('Erro ao criar questão', error)
      }
    },
    criarObjetoDeRespostas(arrayDeRespostas, correctOption) {
      return arrayDeRespostas.map((resposta, index) => ({
      order: index,
      correct: correctOption === index ? 1 : 0,
      description: resposta
  }));
  },
  resetData() {
    this.title = null;
    this.viewtab = true;
    this.titleQuestion = '';
    this.asnwers = [];
    this.correctOption = null;
    this.numberAnswer = 0;
    this.showAsnwer = false;
  },
    saveModule(){
        if(this.numberAnswer>0){
          this.createQuestion();
          this.showmodal = false;
          this.$emit('open-tab', this.showmodal);
          this.resetData();
      } else {
        this.changeView(1)
      }

    },
    changeView(id){
        if(id==0){
            this.viewtab = true;
        } else {
            this.viewtab = false;
        }
    },
    updateContent(index, event){
      this.asnwers[index] = event
    },
    updateAnswers() {
      if(this.numberAnswer!=null){
        this.showAsnwer = true;
      }

    },
  },
  watch: {
    show(novoValor) {
      this.showmodal = this.show;
    },
    numberAnswer(novovalor) {
     this.numberAnswer = novovalor;
    },
    }
};
</script>
<style scoped>
@import "./tabs.css";

.form-create-module.editquestion {
  z-index: 9999 !important;
}
.modal-body {
  padding: 10px !important;
}
.dashboard.dark .form-group {
  margin: 0px !important;
  padding: 7px;
  border: 1px solid #a4a4a4;
  margin-top: 0px !important;
}
.dashboard.dark .input_awmser label {
  color: white;
}
.modal-body {
  margin: 8px;
}
.form-create-module.editquestion .modal-body {
  margin: 0 !important;
  padding: 0 !important;
}
.form-create-module.editquestion  .form-group.text-area {
  margin: 5px !important;
}
</style>
